import ExpertProfileAboutModule from './expert-profile-about.module'

export default ExpertProfileAboutModule
